module.exports = __webpack_public_path__ + "static/media/video_image5.35a5a46b.svg";